import { render, staticRenderFns } from "./loading-screen.vue?vue&type=template&id=9d0874c4&scoped=true"
var script = {}
import style0 from "./loading-screen.vue?vue&type=style&index=0&id=9d0874c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d0874c4",
  null
  
)

export default component.exports